/**
 * slash-app の chat API ヘルパ。レスポンス JSON はそのまま返す
 * (フィールド名は slash-app 仕様)。
 */
import { openSlashAppSocket, slashAppJson } from "./slashAppClient";

export const slashAppChat = {
  /**
   * GET /api/v1/chat/threads/
   * @param {{page?:number, filter?:string, q?:string}} opts
   * @returns {Promise<{page:number, per_page:number, total:number, has_more:boolean, results:Array}>}
   */
  listThreads({ page = 1, filter = "", q = "" } = {}) {
    const params = new URLSearchParams();
    params.set("page", String(page));
    if (filter) params.set("filter", filter);
    if (q) params.set("q", q);
    return slashAppJson(`/api/v1/chat/threads/?${params.toString()}`);
  },

  /**
   * GET /api/v1/chat/threads/<id>/messages/
   * @param {number} threadId
   * @param {{beforeId?:number, perPage?:number}} opts
   */
  listMessages(threadId, { beforeId, perPage = 30 } = {}) {
    const params = new URLSearchParams();
    params.set("per_page", String(perPage));
    if (beforeId != null) params.set("before_id", String(beforeId));
    return slashAppJson(
      `/api/v1/chat/threads/${threadId}/messages/?${params.toString()}`
    );
  },

  /**
   * POST /api/v1/chat/threads/<id>/messages/
   */
  sendText(threadId, text) {
    return slashAppJson(`/api/v1/chat/threads/${threadId}/messages/`, {
      method: "POST",
      body: JSON.stringify({ message_type: "text", text }),
    });
  },

  sendMedia(threadId, message_type, s3_url) {
    return slashAppJson(`/api/v1/chat/threads/${threadId}/messages/`, {
      method: "POST",
      body: JSON.stringify({ message_type, s3_url }),
    });
  },

  /**
   * POST /api/v1/chat/upload/  (multipart/form-data)
   * @returns {Promise<{s3_url:string, message_type:"image"|"video", key:string}>}
   */
  upload(threadId, file) {
    const form = new FormData();
    form.append("thread_id", String(threadId));
    form.append("file", file);
    return slashAppJson("/api/v1/chat/upload/", {
      method: "POST",
      body: form,
    });
  },

  unsend(messageId) {
    return slashAppJson(`/api/v1/chat/messages/${messageId}/unsend/`, {
      method: "POST",
    });
  },

  /**
   * POST /api/v1/chat/messages/<id>/resend-line/
   * LINE への配信に失敗したメッセージを、本文そのままで送り直す。
   * @returns {Promise<Object>} 再送後の message (line_delivery_status 更新済み)
   */
  resendLine(messageId) {
    return slashAppJson(`/api/v1/chat/messages/${messageId}/resend-line/`, {
      method: "POST",
    });
  },

  markRead(threadId) {
    return slashAppJson(`/api/v1/chat/threads/${threadId}/read/`, {
      method: "POST",
    });
  },

  setStatus(threadId, status) {
    return slashAppJson(`/api/v1/chat/threads/${threadId}/status/`, {
      method: "POST",
      body: JSON.stringify({ status }),
    });
  },

  openThreadSocket(threadId) {
    return openSlashAppSocket(`/ws/chat/${threadId}/`);
  },

  openInboxSocket() {
    return openSlashAppSocket(`/ws/admin/chat_inbox/`);
  },
};
